module.exports = __webpack_public_path__ + "static/media/fb-create-adaccount-6-en.0e957639.png";